import React from 'react';
import { PropertyIndicatorContainer } from './utils';
import { PercentDiffValues } from '@/components/tables/cell-renderers/percent-difference-utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '@/lib/utils';

type Props = {
  values: PercentDiffValues | null;
};
export function PercentDifferenceIndicator({ values }: Props) {
  if (!values) return null;
  const { icon, label, percentage, iconColor } = values;

  return (
    <PropertyIndicatorContainer className="bg-gray-100">
      <div className="flex h-full items-center justify-between text-[13px] font-bold">
        <div className="flex flex-1">
          <FontAwesomeIcon size="lg" className={cn(iconColor, 'mr-2 w-4 pl-1')} icon={icon} />
        </div>
        <div className="mr-2 font-bold">{percentage}</div>
        <div className="font-normal">{label}</div>
      </div>
    </PropertyIndicatorContainer>
  );
}
